import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { TokenStorageService } from '../services/token-storage.service';

export const telephonyPageGuard: CanActivateFn = (route) => {
  const router = inject(Router);
  const tokenStorage = inject(TokenStorageService);
  const visibleTo = route.data?.['visibleTo'] as string[] | undefined;
  if (!visibleTo?.length) return true;

  const role = normalizeRole(tokenStorage.decodeToken()?.ROLE ?? tokenStorage.decodeToken()?.role);
  if (!role) return true;
  if (visibleTo.includes(role)) return true;

  router.navigate(['/telephony']);
  return false;
};

function normalizeRole(role?: string): string {
  const value = (role ?? '').toLowerCase();
  if (['admin', 'super_admin'].includes(value)) return 'admin';
  if (['manager', 'supervisor'].includes(value)) return 'supervisor';
  if (['internal_user', 'csr', 'agent'].includes(value)) return 'agent';
  return value;
}
